import { render, staticRenderFns } from "./CreativeStatsTotalModal.vue?vue&type=template&id=6b328b96&scoped=true&"
import script from "./CreativeStatsTotalModal.vue?vue&type=script&lang=js&"
export * from "./CreativeStatsTotalModal.vue?vue&type=script&lang=js&"
import style0 from "./CreativeStatsTotalModal.vue?vue&type=style&index=0&id=6b328b96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b328b96",
  null
  
)

export default component.exports